module.exports = __webpack_public_path__ + "static/media/swab-instruction-step03.86c2b24e.png";